import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56b5a927"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recurrence-section mt-4" }
const _hoisted_2 = { class: "is-flex is-align-items-center" }
const _hoisted_3 = { class: "switch-centered" }
const _hoisted_4 = { class: "switch" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_7 = { class: "ml-2 switch-centered recurrence-toggle-label" }
const _hoisted_8 = {
  key: 0,
  class: "recurrence-fields mt-3"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "label recurrence-field-label" }
const _hoisted_11 = { class: "is-flex is-align-items-center" }
const _hoisted_12 = { class: "control is-expanded recurrence-frequency-select" }
const _hoisted_13 = { class: "field mt-3" }
const _hoisted_14 = { class: "label recurrence-field-label" }
const _hoisted_15 = { class: "control recurrence-datepicker" }
const _hoisted_16 = { class: "field mt-3" }
const _hoisted_17 = { class: "label recurrence-field-label" }
const _hoisted_18 = { class: "has-text-grey" }
const _hoisted_19 = { class: "control recurrence-datepicker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_NumberInputStepper = _resolveComponent("NumberInputStepper")!
  const _component_DropdownButton = _resolveComponent("DropdownButton")!
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: _ctx.enabled,
            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggle && _ctx.handleToggle(...args)))
          }, null, 40, _hoisted_5),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_fa_icon, {
          icon: "sync",
          class: "mr-2"
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.label), 1)
      ])
    ]),
    (_ctx.enabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$gettext("Repeat every")), 1),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_NumberInputStepper, {
                modelValue: _ctx.interval,
                min: 1,
                class: "mr-2",
                placeholder: _ctx.$gettext('1'),
                "input-aria-label": _ctx.$gettext('Frequency interval'),
                "decrement-aria-label": _ctx.$gettext('Decrease frequency'),
                "increment-aria-label": _ctx.$gettext('Increase frequency'),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:interval', $event)))
              }, null, 8, ["modelValue", "placeholder", "input-aria-label", "decrement-aria-label", "increment-aria-label"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_DropdownButton, {
                  options: [
                { value: 'daily', label: _ctx.$gettext('Day(s)') },
                { value: 'weekly', label: _ctx.$gettext('Week(s)') },
                { value: 'monthly', label: _ctx.$gettext('Month(s)') },
                { value: 'yearly', label: _ctx.$gettext('Year(s)') },
              ],
                  modelValue: _ctx.ruleType,
                  customWidth: "100%",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:ruleType', $event)))
                }, null, 8, ["options", "modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$gettext("Start date")), 1),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_date_picker, {
                value: _ctx.startDate || '',
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:startDate', $event || ''))),
                "prefix-class": "xmx",
                "value-type": "format",
                format: "YYYY-MM-DD",
                editable: false,
                clearable: false,
                "disabled-date": _ctx.disabledStartDates,
                "popup-style": _ctx.startDatePopupStyle,
                ref: "startDatePicker",
                onOpen: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDatePickerPopupStyle('start'))),
                placeholder: _ctx.$gettext('Start date')
              }, null, 8, ["value", "disabled-date", "popup-style", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.$gettext("End date")) + " ", 1),
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$gettext("(optional)")), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_date_picker, {
                value: _ctx.endDate || '',
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:endDate', $event || ''))),
                "prefix-class": "xmx",
                "value-type": "format",
                format: "YYYY-MM-DD",
                editable: false,
                "disabled-date": _ctx.disabledEndDates,
                "popup-style": _ctx.endDatePopupStyle,
                ref: "endDatePicker",
                onOpen: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDatePickerPopupStyle('end'))),
                placeholder: _ctx.$gettext('End date')
              }, null, 8, ["value", "disabled-date", "popup-style", "placeholder"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}